/* Native Shopify signup. Entry mode deliberately ignores prior dismissals. */
(() => {
  if (window.boxzyClubReady) return;
  window.boxzyClubReady = true;
  const dialog = document.querySelector('[data-club-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'boxzy-club-welcome-v1';
  const behavior = dialog.dataset.behavior || 'every_entry';
  const repeatEntry = behavior !== 'cooldown';
  let lastFocus, ready = false, shown = false;
  const read = () => { try { return Number(localStorage.getItem(key) || 0); } catch { return 0; } };
  const remember = days => { if (repeatEntry) return; try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {} };
  const isEntry = () => {
    if (behavior === 'every_page') return true;
    const root = window.Shopify?.routes?.root || '/';
    if (location.pathname.replace(/\/$/, '') === root.replace(/\/$/, '')) return true;
    if (performance.getEntriesByType('navigation')[0]?.type === 'reload') return true;
    if (!document.referrer) return true;
    try { return new URL(document.referrer).origin !== location.origin; } catch { return true; }
  };
  const close = () => { if (dialog.open) dialog.close(); };
  const open = manual => {
    if (dialog.open) { shown = true; return true; }
    if (document.querySelector('dialog[open]')) return false;
    if (!manual && (document.hidden || (!repeatEntry && read() > Date.now()))) return false;
    lastFocus = document.activeElement;
    dialog.showModal(); shown = true;
    document.body.classList.add('dialog-open');
    return true;
  };
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-club-close]')) { close(); return; }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });
  dialog.addEventListener('close', () => {
    remember(Number(dialog.dataset.days) || 7);
    document.body.classList.toggle('dialog-open', Boolean(document.querySelector('dialog[open]')));
    if (lastFocus?.isConnected) lastFocus.focus();
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-club-open]')) return;
    event.preventDefault(); open(true);
  });
  dialog.querySelector('[data-club-copy]')?.addEventListener('click', async () => {
    const code = dialog.querySelector('[data-club-code]')?.textContent?.trim();
    const status = dialog.querySelector('[data-club-copy-status]');
    if (!code || !status) return;
    try { await navigator.clipboard.writeText(code); status.textContent = 'Code copied.'; }
    catch { status.textContent = 'Select the code above to copy it.'; }
  });
  if (dialog.querySelector('[data-sms-result]')) { open(true); return; }
  const success = dialog.querySelector('[data-club-success]');
  if (success) {
    remember(365);
    if (new URLSearchParams(location.search).get('customer_posted') === 'true' || location.hash === '#BoxzyClubForm') { open(true); return; }
    if (!repeatEntry) return;
  }
  if (dialog.querySelector('[data-club-error]')) { open(true); return; }
  if (dialog.dataset.auto !== 'true' || (!repeatEntry && (dialog.dataset.subscribed === 'true' || read() > Date.now()))) return;
  if (repeatEntry && !isEntry()) return;
  const autoOpen = () => { if (ready && !shown) open(false); };
  document.addEventListener('visibilitychange', autoOpen);
  document.addEventListener('close', () => setTimeout(autoOpen, 0), true);
  setTimeout(() => { ready = true; autoOpen(); }, Math.max(500, Number(dialog.dataset.delay) || 1000));
})();
